import type React from 'react';
import ActOnSettlementSection from '@/components/features/ActOnSettlement/ActOnSettlementSection';
import PagesLayout, { type PagesLayoutAnalyticsData } from '@/layouts/PagesLayout';
import styles from './ActOnSettlementPage.module.scss';

interface ActOnSettlementPresentationProps {
  handleGoBack: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  analytics: PagesLayoutAnalyticsData;
}

export function ActOnSettlementPage({ handleGoBack, analytics }: ActOnSettlementPresentationProps) {
  return (
    <PagesLayout analytics={analytics}>
      <div className={styles.titleArea}>
        資金決済法に基づく表示
        {/* biome-ignore lint/a11y/useValidAnchor: 最小限の変更でReactリプレースを行うため。リプレース後に対応する */}
        <a href="#" className={styles.titleArea_backLink} onClick={handleGoBack}>
          <span className={styles.iconArrowLeft} />
        </a>
      </div>

      <div className={`${styles.box} ${styles.boxPadding} ${styles.contract}`}>
        <ActOnSettlementSection title="前払式支払手段発行事業者">
          <pre>
            {`株式会社with
〒150-0013
東京都渋谷区恵比寿一丁目19番19号
恵比寿ビジネスタワー`}
          </pre>
        </ActOnSettlementSection>

        <ActOnSettlementSection title="支払い可能金額">
          保有するwithポイントが10,000ポイントを超えることとなる場合は、withポイントを購入することができません。
        </ActOnSettlementSection>

        <ActOnSettlementSection title="有効期限">
          AppleID決済以外で購入されたポイントの有効期限は購入日より180日です。
          AppleID決済で購入されたポイントの有効期限はありません。
          当社は、最終のアクセスから１年間以上経過しているアカウントを、あらかじめお客様に通知することなく削除することができます。この場合、未使用のポイントは購入・付与分に関わらず失効します。
        </ActOnSettlementSection>

        <ActOnSettlementSection title="ご利用いただけるサービス">
          「with」内でのサービスにお使い頂けます。
        </ActOnSettlementSection>

        <ActOnSettlementSection title="ご利用上の注意事項">
          原則として、withポイントの払い戻しはいたしません。
          サービスを退会されますと、withポイントも失効となりますのでご注意ください。
          withポイントに関して詳しくはサイト上のよくある質問をご覧ください。
          withポイントは購入されたwithポイントのうち、有効期限が近いポイントから順に消費されます。
        </ActOnSettlementSection>

        <ActOnSettlementSection title="未使用残高の確認方法">
          サイト上の「ポイント」ページ、アプリの「マイページ」よりご確認頂けます。
        </ActOnSettlementSection>

        <ActOnSettlementSection title="withポイントの発行及び利用に関する苦情または相談の受付窓口">
          <div className={styles.size3}>
            株式会社with 「with」個人情報お問い合わせ窓口担当
            <br />
            ＜住所＞　〒150-0013 東京都渋谷区恵比寿一丁目19番19号　恵比寿ビジネスタワー17F
            <br />
            ＜E-mail＞ support@with.is
          </div>
        </ActOnSettlementSection>

        <ActOnSettlementSection title="利用規約">
          {/* TODO: terms_of_use ページをinertia でリプレースしたのち、Linkコンポーネントに置き換える */}
          <a href="/terms_of_use" className={`${styles.textLink} ${styles.textPrimary} ${styles.textUnderline}`}>
            こちら
          </a>
          をご覧ください
        </ActOnSettlementSection>

        <ActOnSettlementSection title="利用者資金の保全方法">
          当社は、前払式支払手段の保有者の保護のために、資金決済に関する法律第14条第1項の規定の趣旨に基づき、基準日未使用残高（毎年3月31日及び9月30日時点における未使用残高で、資金決済に関する法律第3条第2項の規定に基づき算出したものをいいます）の2分の1以上の額を保証金額としてみずほ銀行青山支店との間で発行保証金保全契約を締結することにより資産保全を行っております。
          ※ 必ずしも全額保全が図られているわけではございません。
          <br />
          当社の経営破綻により前払式支払手段が利用できなくなった場合、前払式支払手段の保有者は、資金決済に関する法律第31条の規定に基づき、あらかじめ保全された発行保証金について、他の債権者に先立ち弁済を受けることができます。
        </ActOnSettlementSection>

        <ActOnSettlementSection title="不正利用による損失の補償等に関する方針">
          当社は、前払式支払手段の不正利用（前払式支払手段の保有者の意思に反した、権限を有しない者の指図による前払式支払手段の利用のことをいいます）により、当該保有者に生じた損失について、利用規約又は法令に基づき当社が責任を負う場合を除き、一切の責任を負わないものとします。
          心当たりのない利用又は請求にお気づきの時点で、上記「お問い合わせ先」までご連絡ください。
          当社以外の事業者が提供する連携サービスにおいて不正利用が疑われる場合は、当該連携サービスの相談窓口・連絡先まで速やかにご連絡ください。
          なお、かかる連絡に際しては、連携サービス所定の手続に従っていただく必要がございます。
          各連携サービスにおいて生じた損害の補償については当該連携サービスの提供元へとお問い合わせください。
          但し、当該連携サービスの提供元が補償を行うことを保証するものではありません。
          不正取引の公表の要否の判断を含め、不正取引の公表は当該連携サービスの提供元が行います。
          当社は、不正取引が発生した場合、またはその恐れがある場合について、当該不正取引の態様を踏まえ、被害額や件数等の事情を加味し、被害の拡大（二次被害）を防止するために必要があると当社が判断したとき、類似の事案の発生を回避するために有益であると当社が判断したとき、または、社会的な影響が大きいと当社が認めたときは、速やかに必要な情報を公表します。
        </ActOnSettlementSection>
      </div>
    </PagesLayout>
  );
}
